import type { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import type { SavedLocation } from "@freightsimple/generated-dashboard-openapi-client/models/SavedLocation";
import type { ReactNode } from "react";
import { useState } from "react";
import type { LocationsModifyResult } from "../Dialogs/LocationsModifyDialog";
import { LocationsModifyDialog } from "../Dialogs/LocationsModifyDialog";

// Declarative replacement for the imperative useLocationsModifyLocationDialog. Same
// callback contract: `callback` fires only when the wizard completes.
export function useLocationsModifyLocationDialog(
  context: LocationContext,
  callback: (result: LocationsModifyResult) => void,
): { show: (locationToModify: SavedLocation) => void; dialogs: ReactNode } {
  const [open, setOpen] = useState(false);
  const [openCount, setOpenCount] = useState(0);
  const [locationToModify, setLocationToModify] = useState<
    SavedLocation | undefined
  >(undefined);

  function show(savedLocation: SavedLocation) {
    setLocationToModify(savedLocation);
    setOpenCount((count) => count + 1);
    setOpen(true);
  }

  const dialogs = locationToModify !== undefined && (
    <LocationsModifyDialog
      key={`locations-modify-${openCount}`}
      open={open}
      onOpenChange={setOpen}
      context={context}
      locationToModify={locationToModify}
      onFinished={callback}
    />
  );

  return { show, dialogs };
}
